"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VulnerableCustomerActionHelper = exports.VulnerableCustomerActionEnum = void 0;
var VulnerableCustomerActionEnum;
(function (VulnerableCustomerActionEnum) {
    VulnerableCustomerActionEnum["NONE"] = "NONE";
    VulnerableCustomerActionEnum["CANCEL_FUTURE_INTEREST"] = "CANCEL_FUTURE_INTEREST";
    VulnerableCustomerActionEnum["SUSPEND_INTEREST"] = "SUSPEND_INTEREST";
    VulnerableCustomerActionEnum["PAYMENT_HOLIDAY"] = "PAYMENT_HOLIDAY";
    VulnerableCustomerActionEnum["STOP_FUTURE_CANCELLATION_FEES"] = "STOP_FUTURE_CANCELLATION_FEES";
    VulnerableCustomerActionEnum["REFUND_CANCELLATION_FEE"] = "REFUND_CANCELLATION_FEE";
})(VulnerableCustomerActionEnum || (exports.VulnerableCustomerActionEnum = VulnerableCustomerActionEnum = {}));
var VulnerableCustomerActionHelper = /** @class */ (function () {
    function VulnerableCustomerActionHelper() {
    }
    VulnerableCustomerActionHelper.getActionEndpointPathName = function (action) {
        switch (action) {
            case VulnerableCustomerActionEnum.CANCEL_FUTURE_INTEREST:
                return "cancelFutureInterest";
            case VulnerableCustomerActionEnum.SUSPEND_INTEREST:
                return "suspendInterest";
            case VulnerableCustomerActionEnum.PAYMENT_HOLIDAY:
                return "paymentHoliday";
            case VulnerableCustomerActionEnum.STOP_FUTURE_CANCELLATION_FEES:
                return "stopFutureCancellationFees";
            case VulnerableCustomerActionEnum.REFUND_CANCELLATION_FEE:
                return "refundCancellationFee";
            case VulnerableCustomerActionEnum.NONE:
                throw new Error("No translation for ".concat(VulnerableCustomerActionEnum.NONE, ": not an action"));
            default:
                throw new Error("Unknown Vulnerable Customer Action: ".concat(action));
        }
    };
    VulnerableCustomerActionHelper.getActionText = function (action) {
        switch (action) {
            case "NONE":
                return "None";
            case "CANCEL_FUTURE_INTEREST":
                return "Cancel future interest";
            case "PAYMENT_HOLIDAY":
                return "Payment holiday";
            case "STOP_FUTURE_CANCELLATION_FEES":
                return "Stop future cancellation fees";
            case "REFUND_CANCELLATION_FEE":
                return "Refund cancellation fee";
            case "SUSPEND_INTEREST":
                return "Suspend interest";
            default:
                throw new Error("Unknown Vulnerable Customer Action: ".concat(action));
        }
    };
    return VulnerableCustomerActionHelper;
}());
exports.VulnerableCustomerActionHelper = VulnerableCustomerActionHelper;
//# sourceMappingURL=VulnerableCustomerAction.js.map